module.exports = __webpack_public_path__ + "img/pcbg27.8d87a805.jpg";